import { Guid } from "guid-typescript";

export class AppSignature {
    id: string = Guid.createEmpty().toString();
    rowId: number = 0;
    createdBy: string = Guid.createEmpty().toString();
    createdTime: string = "0001-01-01T00:00:00";
    modifiedBy: string = Guid.createEmpty().toString();
    modifiedTime: string = "0001-01-01T00:00:00";
}